import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  current: {},
  statistics: {},
  list: []
}

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    setCompaniesList: (state, { payload }) => ({ ...state, list: [...payload.companies] }),
    setCurrentCompany: (state, { payload }) => ({ ...state, current: { ...payload.company } }),
    setCurrentCompanyStatistics: (state, { payload }) => ({ ...state, statistics: { ...payload.statistics } }),
    resetCompaniesState: () => ({ list: [], current: { }, statistics: { } })
  }
});

export const { setCompaniesList, setCurrentCompany, resetCompaniesState, setCurrentCompanyStatistics } = companiesSlice.actions;
export default companiesSlice.reducer;
